import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { EventsService } from 'angular4-events';
import { DataService } from '../data.service';
declare var $;
@Component({
  selector: 'app-problem-detail',
  templateUrl: './problem-detail.component.html',
  styleUrls: ['./problem-detail.component.css']
})
export class ProblemDetailComponent implements OnInit {
  issueID:any;
  issueDetail:any;
  orderDetail:any;
  productData :any;
  businessDetail:any;
  deliveryAddress:any;
  constructor(private dataService:DataService,private route: ActivatedRoute) {

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.issueID = params['id'];
      // Do something with the ID, like fetch data from a service
    });
    this.getProblemReportDetail();


  }

getProblemReportDetail(){
  this.dataService.getProblemDetail(window.localStorage.getItem('token'),this.issueID).subscribe((data:any) => {
    debugger;
  this.issueDetail = data.ticket_dict;
  this.orderDetail= data.order;
  this.productData = data.product;
  this.businessDetail = data.dispensary;
    this.deliveryAddress = data.dropoff_address
})
}
}



// WEBPACK FOOTER //
// ./src/app/problem-detail/problem-detail.component.ts